import { useUnit } from 'effector-react';
import { $store } from 'models/store';

/**
 * Парсит строку с номерами магазинов из переменной окружения
 * @param envValue - значение переменной окружения
 * @returns массив номеров магазинов
 */
const parseStoreNumbers = (envValue: string | undefined): number[] => {
	return envValue
		? envValue
				.split(',')
				.map(num => parseInt(num.trim(), 10))
				.filter(num => !isNaN(num))
		: [];
};

/**
 * Создает хук для проверки принадлежности текущего магазина к списку
 * @param storeNumbers - массив номеров магазинов
 * @returns функция-хук
 */
const createStoreFilter = (storeNumbers: number[]) => {
	return (): boolean => {
		const store = useUnit($store);
		if (!store?.number) return false;
		return storeNumbers.includes(+store.number);
	};
};

// Для продавцов
const sellerStoreNumbers = parseStoreNumbers(process.env.REACT_APP_STORE_NUMBERS_SELLERS_ONLY);
export const useSellerOnlyStores = createStoreFilter(sellerStoreNumbers);

// Для кассиров
const cashierStoreNumbers = parseStoreNumbers(process.env.REACT_APP_STORE_NUMBERS_CASHIERS_ONLY);
export const useCashierOnlyStores = createStoreFilter(cashierStoreNumbers);

// Для кнопки "Добавить исполнителя по уборке"
const cleanerButtonStoreNumbers = parseStoreNumbers(process.env.REACT_APP_STORE_NUMBERS_CLEANER_ONLY);
export const useCleanerButtonVisible = createStoreFilter(cleanerButtonStoreNumbers);

// Для My Gig продавцов
const myGigSellerStoreNumbers = parseStoreNumbers(process.env.REACT_APP_STORE_NUMBERS_MYGIG_SELLERS);
export const useMyGigSellerStores = createStoreFilter(myGigSellerStoreNumbers);
console.log({sellerStoreNumbers, myGigSellerStoreNumbers})

// Для My Gig кассиров
const myGigCashierStoreNumbers = parseStoreNumbers(process.env.REACT_APP_STORE_NUMBERS_MYGIG_CASHIERS);
export const useMyGigCashierStores = createStoreFilter(myGigCashierStoreNumbers);
